import React from "react";

export function ChartToolBar(props) {
    return (
        <>
            <div className={"time-ranges"} id="chart-timeframe-guide">
                {props.periods.map(props.callbackfn)}
            </div>
            {/* Optionally render icons; hidden for Buy/Sell when hideIcons is true */}
            {!props.hideIcons && (
                <div className={"fixed-icons"} id="chart-drawing-tools-guide">
                    <i className={"fa fa-pencil"} onClick={props.onClick} />
                    <i className={"fa fa-cog"} onClick={props.onClick1} />
                </div>
            )}
        </>
    );
}